// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2aXfS","notes":"Notes_notes__1_jFB"};